import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "edit-skill-container"
};
const _hoisted_2 = {
  class: "skill-name"
};
const _hoisted_3 = {
  class: "skill-explain"
};
const _hoisted_4 = {
  class: "skill-deep-desc"
};
const _hoisted_5 = {
  class: "edit-item-title"
};
const _hoisted_6 = {
  class: "edit-item-title"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "operator-container"
};
import { ref, onMounted, computed } from 'vue';
import { ElButton, ElInput, ElInputNumber, ElMessage, ElRow, ElSwitch } from 'element-plus';
import { request } from '@/manager/net_manager';
import { inApostleType, isValid } from '@/tools/utils';
import store from '@/store';
export default {
  __name: 'RoleSkillEditCard',
  props: {
    skill: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'complete'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const degreeOptions = ['C', 'B', 'A', 'S', 'SS']; // refs

    const message = ref(null);
    const updatesForm = ref({
      id: null,
      increase_count: 0,
      grew_value: 0,
      skilled: false,
      skilled_path: '',
      over_limit: false,
      over_limit_path: '',
      mutates: false,
      mutates_type: '',
      name: '',
      degree: 0,
      mysterious_level: 0,
      desc: '',
      deep_desc: ''
    }); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : null); // functions

    const getSkillDesc = item => {
      const sectsName = item.sects.name;
      const isPrivate = item.is_private ? '秘传' : '';
      const degreeLevel = `${item.degree}级`;
      const skillType = isValid(item.skill_type) ? item.skill_type.desc : '不明';
      const conventional = item.conventional ? '常规施法' : '构筑施法';
      const powerType = isValid(item.power_type) ? item.power_type.desc : '不明';
      let skillDesc = `${sectsName} · ${degreeLevel}${isPrivate} · ${powerType} · ${skillType} · ${conventional}`;

      if (inApostleType(userType.value)) {
        return `${skillDesc} · 神秘${item.mysterious_level}`;
      }

      return skillDesc;
    };

    const removeSkill = () => {
      if (message.value) {
        message.value.close();
      }

      request('skills/role_skills/remove/', {
        'role_skill_id': updatesForm.value.id
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '技能项已清除',
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    };

    const exerciseSkill = () => {
      if (message.value) {
        message.value.close();
      }

      request('skills/role_skills/exercise/', {
        'role_skill_id': updatesForm.value.id
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: response.msg,
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    };

    const updateSkill = () => {
      if (message.value) {
        message.value.close();
      }

      request('skills/role_skills/update/', {
        'updates': updatesForm.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '技能项已调整',
          duration: 1500
        });
        emits('complete');
        emits('close');
      });
    }; // lifecycle


    onMounted(() => {
      // console.log('onMounted', JSON.stringify(props.skill))
      updatesForm.value = {
        id: props.skill.id,
        increase_count: props.skill.increase_count,
        grew_value: props.skill.grew_value,
        skilled: props.skill.skilled.toString().toUpperCase() === 'TRUE',
        skilled_path: props.skill?.skilled_path ?? '',
        over_limit: props.skill.over_limit.toString().toUpperCase() === 'TRUE',
        over_limit_path: props.skill?.over_limit_path ?? '',
        mutates: props.skill.mutates.toString().toUpperCase() === 'TRUE',
        mutates_type: props.skill?.mutates_type ?? '',
        name: props.skill.name,
        degree: degreeOptions.indexOf(props.skill.degree) + 1,
        mysterious_level: props.skill.mysterious_level,
        desc: props.skill.desc,
        deep_desc: props.skill.deep_desc
      };
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_col, null, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_2, _toDisplayString(__props.skill.name), 1)]),
          _: 1
        }), _createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_3, _toDisplayString(getSkillDesc(__props.skill)), 1)]),
          _: 1
        }), _createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.skill.desc), 1)]),
          _: 1
        }), _unref(isValid)(__props.skill.deep_desc) ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_4, _toDisplayString(__props.skill.deep_desc), 1)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _cache[34] || (_cache[34] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createVNode(_unref(ElRow), {
        style: {
          "align-items": "flex-start"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            style: {
              "margin-top": "0"
            }
          }, {
            default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "投入精进次数", -1)), _createVNode(_unref(ElInputNumber), {
              modelValue: updatesForm.value.increase_count,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => updatesForm.value.increase_count = $event),
              min: 0,
              max: 100,
              placeholder: "精进点数"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_5, "奇遇调整点数（当前最大成功率" + _toDisplayString(__props.skill.max_value) + "）", 1), _createVNode(_unref(ElInputNumber), {
              modelValue: updatesForm.value.grew_value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updatesForm.value.grew_value = $event),
              min: -100,
              max: 100,
              placeholder: "调整数值"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _cache[23] || (_cache[23] = _createElementVNode("div", {
            class: "divider"
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "能力专精（+10）", -1)), _createVNode(_unref(ElSwitch), {
              modelValue: updatesForm.value.skilled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => updatesForm.value.skilled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "专精途径", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.skilled_path,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => updatesForm.value.skilled_path = $event),
              maxlength: "16",
              placeholder: "专精渠道描述",
              round: "",
              type: "text",
              clearable: "",
              "show-word-limit": ""
            }, null, 8, ["modelValue"]), _cache[16] || (_cache[16] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, " 专精的+10提升与异化带来的+10提升属于同类别，不做叠加 ", -1))]),
            _: 1
          }), _cache[24] || (_cache[24] = _createElementVNode("div", {
            class: "divider"
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "超限（500）", -1)), _createVNode(_unref(ElSwitch), {
              modelValue: updatesForm.value.over_limit,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => updatesForm.value.over_limit = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "超限途径", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.over_limit_path,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => updatesForm.value.over_limit_path = $event),
              maxlength: "16",
              placeholder: "超限途径描述",
              round: "",
              type: "text",
              clearable: "",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _cache[25] || (_cache[25] = _createElementVNode("div", {
            class: "divider"
          }, null, -1)), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "异变发生", -1)), _createVNode(_unref(ElSwitch), {
              modelValue: updatesForm.value.mutates,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => updatesForm.value.mutates = $event)
            }, null, 8, ["modelValue"]), _cache[20] || (_cache[20] = _createElementVNode("text", {
              class: "edit-item-tips alert-info"
            }, " 【如果从异变状态切换至非异变状态，将会重置\"等阶/神秘等级/描述/深层描述\"项目至原技能状态】 ", -1))]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[21] || (_cache[21] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "异变类型", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.mutates_type,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => updatesForm.value.mutates_type = $event),
              maxlength: "16",
              placeholder: "异变类型描述",
              round: "",
              type: "text",
              clearable: "",
              "show-word-limit": ""
            }, null, 8, ["modelValue"]), _cache[22] || (_cache[22] = _createElementVNode("text", {
              class: "edit-item-tips"
            }, " 常规异变类型仅有三种：奥术/神话/深层，其中奥术贴近能量本源，神话贴近神明力量，深层贴近底层真理 ", -1))]),
            _: 1
          })]),
          _: 1
        }), updatesForm.value.mutates ? (_openBlock(), _createBlock(_component_el_col, {
          key: 0,
          offset: 1,
          span: 13
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            style: {
              "margin-top": "0"
            }
          }, {
            default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "异变变更 - 技能名", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.name,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => updatesForm.value.name = $event),
              maxlength: "16",
              placeholder: "技能名",
              round: "",
              type: "text",
              clearable: "",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_6, [_cache[27] || (_cache[27] = _createTextVNode(" 异变变更 - 等阶 ", -1)), updatesForm.value.degree > 0 && updatesForm.value.degree <= degreeOptions.length ? (_openBlock(), _createElementBlock("span", _hoisted_7, " ：" + _toDisplayString(degreeOptions[updatesForm.value.degree - 1]), 1)) : _createCommentVNode("", true)]), _createVNode(_unref(ElInputNumber), {
              modelValue: updatesForm.value.degree,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => updatesForm.value.degree = $event),
              min: 1,
              max: 5
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "异变变更 - 神秘等级", -1)), _createVNode(_unref(ElInputNumber), {
              modelValue: updatesForm.value.mysterious_level,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => updatesForm.value.mysterious_level = $event),
              min: 1,
              max: 12
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "form-row"
          }, {
            default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "异变变更 - 技能描述", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.desc,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => updatesForm.value.desc = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "技能描述",
              maxlength: "256"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "form-row"
          }, {
            default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("text", {
              class: "edit-item-title"
            }, "异变变更 - 深层描述", -1)), _createVNode(_unref(ElInput), {
              modelValue: updatesForm.value.deep_desc,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => updatesForm.value.deep_desc = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "技能深层描述",
              maxlength: "256"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(ElButton), {
        class: "remove-skill",
        onClick: removeSkill
      }, {
        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode(" 移除技能 ", -1)]))]),
        _: 1
      }), __props.skill.probability < __props.skill.max_value ? (_openBlock(), _createBlock(_unref(ElButton), {
        key: 0,
        onClick: exerciseSkill
      }, {
        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode(" 演出成长 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElButton), {
        onClick: updateSkill
      }, {
        default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode(" 提交变更 ", -1)]))]),
        _: 1
      })])]);
    };
  }

};